import { NgModule } from '@angular/core';
import { MediaWatcherService } from '@core/services/media-watcher/media-watcher.service';

@NgModule({
    providers: [
        MediaWatcherService
    ]
})
export class MediaWatcherModule
{ }
